import {
    alpha,
    ListItemButton,
    ListItemButtonProps,
    ListItemText,
} from "@mui/material";

export default function FilterListButton({
    children,
    sx,
    ...props
}: ListItemButtonProps) {
    return (
        <ListItemButton
            {...props}
            sx={{
                width: "100%",
                "&:hover": {
                    color: "primary.main",
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
                },
                ...sx,
            }}
        >
            <ListItemText>{children}</ListItemText>
        </ListItemButton>
    );
}
